import React from 'react';
import { BaseContent, ConfirmModal, useModalContext } from '@fourthwall/components';
export const UnavailableSlugModal = ({ suggestedSlug, subtitle, onConfirm, onCancel, }) => {
    const { close } = useModalContext();
    return (React.createElement(ConfirmModal, { title: "Provided domain is unavailable", size: "medium", text: React.createElement(BaseContent, null,
            React.createElement("p", null, subtitle),
            React.createElement("p", null,
                "Please use: ",
                React.createElement("br", null),
                " ",
                React.createElement("strong", null, suggestedSlug))), confirmLabel: "Use suggested domain", onConfirm: onConfirm, onCancel: onCancel, close: close }));
};
